import { InterfaceData } from "./interface.data";

export class UpdateSupplierInterfaceDataRequest {
  Updated: InterfaceData[];
  Deleted: InterfaceData[];
}